import request from '@/utils/request'

// 获取设备的最后位置信息
export function getGNSSLastByMcuID(params) {
  if (!params.myToken) {
    return request({
      url: '/v3/location/getGNSSLastByMcuID',
      method: 'post',
      headers: { 'token': 'nmamtf' },
      data: params
    })
  } else {
    return request({
      url: '/v3/location/getGNSSLastByMcuID',
      method: 'post',
      data: params
    })
  }
}
// 根据参数获取GNSS数据
export function getGNSSByMcuID(params) {
  return request({
    url: '/v3/location/getGNSSByMcuID',
    method: 'post',
    data: params
  })
}

